module.exports = __webpack_public_path__ + "img/ic_feature_playlists.1500a97f.svg";